"use client";

import { useEffect } from "react";

/**
 * KAN-317: dev-only трекинг производительности.
 * - Long tasks (>50мс) через PerformanceObserver с атрибуцией в консоль.
 * - Периодический снимок performance.memory (Chromium) — детект роста кучи
 *   при навигации (утечки).
 * В прод-бандл не попадает поведением: в production компонент — no-op.
 */
export function DevPerfTracker() {
  useEffect(() => {
    if (process.env.NODE_ENV === "production") return;

    let observer: PerformanceObserver | null = null;
    try {
      observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          const attribution = (entry as unknown as {
            attribution?: Array<{ containerType?: string; containerName?: string }>;
          }).attribution?.[0];
          console.warn(
            `[PERF] long task ${Math.round(entry.duration)}ms`,
            attribution?.containerName || attribution?.containerType || "",
            `@ ${window.location.pathname}`,
          );
        }
      });
      observer.observe({ type: "longtask", buffered: true });
    } catch {
      // longtask не поддерживается — ок
    }

    let lastHeap = 0;
    const memTimer = setInterval(() => {
      const mem = (performance as unknown as {
        memory?: { usedJSHeapSize: number };
      }).memory;
      if (!mem) return;
      const usedMb = mem.usedJSHeapSize / 1024 / 1024;
      // Репортим только заметный рост, чтобы не шуметь
      if (lastHeap > 0 && usedMb - lastHeap > 20) {
        console.warn(
          `[PERF] JS heap вырос: ${Math.round(lastHeap)}МБ → ${Math.round(usedMb)}МБ @ ${window.location.pathname}`,
        );
      }
      lastHeap = usedMb;
    }, 15_000);

    return () => {
      observer?.disconnect();
      clearInterval(memTimer);
    };
  }, []);

  return null;
}
